class LazyLoad {
  constructor(selector = '.lazy-load', options = {}) {
    this.selector = selector;
    this.options = {
      rootMargin: '100px 0px',
      threshold: 0.1,
      animationDelay: 50,
      ...options
    };
    
    this.observer = null;
    this.elements = [];
    
    this.init();
  }

  init() {
    // Get all lazy load elements
    this.elements = document.querySelectorAll(this.selector);
    
    if (this.elements.length === 0) {
      return;
    }

    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
      this.createObserver();
      this.observeElements();
    } else {
      // Fallback for older browsers
      this.loadAllElements();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadElement(entry.target);
          this.observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: this.options.rootMargin,
      threshold: this.options.threshold
    });
  }

  observeElements() {
    this.elements.forEach((element) => {
      this.observer.observe(element);
    });
  }

  loadElement(element) {
    // Use requestAnimationFrame for smoother animation
    // Add minimal delay for stagger effect based on visible position
    const visibleElements = Array.from(this.elements).filter(el => {
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
    const visibleIndex = visibleElements.indexOf(element);
    const delay = visibleIndex * this.options.animationDelay;
    
    // Use requestAnimationFrame for smoother animation start
    requestAnimationFrame(() => {
      setTimeout(() => {
        element.classList.remove('opacity-0', 'translate-y-4');
        element.classList.add('opacity-100', 'translate-y-0');
      }, delay);
    });
  }

  loadAllElements() {
    // Fallback for older browsers - load all elements immediately
    this.elements.forEach((element, index) => {
      const delay = index * this.options.animationDelay;
      setTimeout(() => {
        element.classList.remove('opacity-0', 'translate-y-4');
        element.classList.add('opacity-100', 'translate-y-0');
      }, delay);
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  // Method to reinitialize after dynamic content changes
  refresh() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.init();
  }
}

export default LazyLoad;
